import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, Text, Card, Heading, Grid, DataList, Button } from '@radix-ui/themes';
import UserAvatar from '../common/UserAvatar';
import GeneralInfoProfileForm from '../forms/GeneralInfoProfileForm';
import ProfilePictureForm from '../forms/ProfilePictureForm';
import SchoolDetailsForm from '../forms/school/SchoolDetailsForm';
import SchoolCrestForm from '../forms/SchoolCrestForm';
import PaymentSettingsForm from '../forms/PaymentSettingsForm';
import api from '../../api';

const SchoolAdminProfile = () => {
    const user = useSelector((state) => state.user.details);
    const schoolDetails = useSelector((state) => state.schoolAdmin.school);
    const [isEditing, setIsEditing] = useState(false);
    const [isEditingSchoolDetails, setIsEditingSchoolDetails] = useState(false);
    const [isEditingPaymentSettings, setIsEditingPaymentSettings] = useState(false);


    return (
        <Box width="100%" maxWidth="1080px">
            <Grid columns="12" gap="4">
                <Box gridColumnStart="1" gridColumnEnd="13" gridRowStart="1">
                    <Card>
                        <Flex direction="column" gap="4">
                            <Flex direction="row" gap="4" align="center">
                                <ProfilePictureForm user={user} size="6" />
                                {/* <Flex direction="column" gap="1">
                                    <Heading size="4">{user.firstname} {user.lastname}</Heading>
                                    <Text size="2" color="gray">{user.email ?? 'N/A'}</Text>
                                </Flex> */}
                            </Flex>
                        </Flex>
                    </Card>
                </Box>

                <Box gridColumn="1 / span 6" gridRowStart="2">
                    <Card>
                        <Flex direction="row" justify="between" align="center">
                            <Heading size="4">General Information</Heading>
                            <Button onClick={() => setIsEditing(!isEditing)}>
                                {isEditing ? 'Cancel' : 'Edit'}
                            </Button>
                        </Flex>
                        {isEditing ? (
                            <GeneralInfoProfileForm setIsEditing={setIsEditing} />
                        ) : (
                            <DataList.Root>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Firstname</DataList.Label>
                                    <DataList.Value>{user.firstname}</DataList.Value>
                                </DataList.Item>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Lastname</DataList.Label>
                                    <DataList.Value>{user.lastname}</DataList.Value>
                                </DataList.Item>
                                <DataList.Item>
                                    <DataList.Label minWidth="100px">Email</DataList.Label>
                                    <DataList.Value>{user.email ?? 'N/A'}</DataList.Value>
                                </DataList.Item>
                            </DataList.Root>
                        )}
                    </Card>
                </Box>

                <Box gridColumn="7 / span 6" gridRowStart="2">
                    <Card>
                        <Flex direction="column" gap="4">
                            <Flex direction="row" gap="4" align="center">
                                <SchoolCrestForm school={schoolDetails} size="6" />
                                <Flex direction="column" gap="1" className="w-full">
                                    <Flex direction="row" justify="between" align="center">
                                        <Heading size="4">School Information</Heading>
                                        <Button onClick={() => setIsEditingSchoolDetails(!isEditingSchoolDetails)}>
                                            {isEditingSchoolDetails ? 'Cancel' : 'Edit'}
                                        </Button>
                                    </Flex>
                                    {isEditingSchoolDetails ? (
                                        <SchoolDetailsForm setIsEditing={setIsEditingSchoolDetails} />
                                    ) : (
                                        <DataList.Root>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">School Name</DataList.Label>
                                                <DataList.Value>{schoolDetails.name}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Sector</DataList.Label>
                                                <DataList.Value>{schoolDetails.sector}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Phone Number</DataList.Label>
                                                <DataList.Value>{schoolDetails.phone ?? 'N/A'}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Email</DataList.Label>
                                                <DataList.Value>{schoolDetails.email ?? 'N/A'}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Country</DataList.Label>
                                                <DataList.Value>{schoolDetails.country?.name ?? 'N/A'}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Region</DataList.Label>
                                                <DataList.Value>{schoolDetails.region?.name ?? 'N/A'}</DataList.Value>
                                            </DataList.Item>
                                            <DataList.Item>
                                                <DataList.Label minWidth="100px">Location</DataList.Label>
                                                <DataList.Value>{schoolDetails.location ?? 'N/A'}</DataList.Value>
                                            </DataList.Item>
                                        </DataList.Root>
                                    )}
                                </Flex>
                            </Flex>
                        </Flex>
                    </Card>
                </Box>

                <Box gridColumn="7 / span 6" gridRowStart="3">
                    <Card>
                        <Flex direction="row" justify="between" align="center">
                            <Heading size="4">Payment Settings</Heading>
                            <Button onClick={() => setIsEditingPaymentSettings(!isEditingPaymentSettings)}>
                                {isEditingPaymentSettings ? 'Cancel' : 'Edit'}
                            </Button>
                        </Flex>
                        {isEditingPaymentSettings ? (
                            <PaymentSettingsForm setIsEditing={setIsEditingPaymentSettings} />
                        ) : (
                            <>
                                {/* <Text size="2" color="gray" mb="4">
                                    The charge amount is split among three entities: Service Fee (fixed at 20%), School (set between 20% and 60%),
                                    and Teachers (remaining percentage).
                                </Text> */}

                                <DataList.Root>
                                    <DataList.Item>
                                        <DataList.Label minWidth="100px">Charge Amount</DataList.Label>
                                        <DataList.Value>{schoolDetails.payment_setting?.charge_amount ?? '40'}</DataList.Value>
                                    </DataList.Item>
                                    <DataList.Item>
                                        <DataList.Label minWidth="100px">School Percentage</DataList.Label>
                                        <DataList.Value>{schoolDetails.payment_setting?.school_percentage ?? '40'}%</DataList.Value>
                                    </DataList.Item>
                                </DataList.Root>
                            </>

                        )}
                    </Card>
                </Box>
            </Grid>
        </Box>
    );
};

export default SchoolAdminProfile;